import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const CONFETTI_COLORS = ['#D4AF37', '#FACC15', '#8B5CF6', '#A78BFA', '#FFFFFF'];
const PARTICLE_COUNT = 40;
interface Particle {
  id: number;
  x: number;
  y: number;
  size: number;
  color: string;
  duration: number;
  delay: number;
  angle: number;
  velocity: number;
}
export function PremiumBonusEffect() {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.3
  });
  const [particles, setParticles] = useState<Particle[]>([]);
  const [showConfetti, setShowConfetti] = useState(false);
  useEffect(() => {
    if (isInView) {
      const newParticles = Array.from({
        length: PARTICLE_COUNT
      }).map((_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 4 + 2,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        duration: Math.random() * 3 + 2,
        delay: Math.random() * 2,
        angle: Math.random() * 360,
        velocity: Math.random() * 20 + 10
      }));
      setParticles(newParticles);
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [isInView]);
  return <div ref={containerRef} className="absolute inset-0 pointer-events-none overflow-hidden z-0" data-id="element-358">
      <AnimatePresence data-id="element-359">
        {showConfetti && <>
            {/* Left Side Burst */}
            {Array.from({
          length: 20
        }).map((_, i) => <motion.div key={`left-${i}`} initial={{
          x: '-5%',
          y: '50%',
          opacity: 1,
          scale: 0,
          rotate: 0
        }} animate={{
          x: `${Math.random() * 40 + 5}%`,
          y: `${Math.random() * 80 + 10}%`,
          opacity: [1, 1, 0],
          scale: [0, 1, 0.5],
          rotate: Math.random() * 720
        }} transition={{
          duration: 2,
          ease: 'easeOut',
          delay: Math.random() * 0.2
        }} className="absolute w-2 h-2 rounded-sm" style={{
          backgroundColor: CONFETTI_COLORS[i % CONFETTI_COLORS.length]
        }} data-id="element-360" />)}

            {/* Right Side Burst */}
            {Array.from({
          length: 20
        }).map((_, i) => <motion.div key={`right-${i}`} initial={{
          x: '105%',
          y: '50%',
          opacity: 1,
          scale: 0,
          rotate: 0
        }} animate={{
          x: `${95 - Math.random() * 40}%`,
          y: `${Math.random() * 80 + 10}%`,
          opacity: [1, 1, 0],
          scale: [0, 1, 0.5],
          rotate: Math.random() * 720
        }} transition={{
          duration: 2,
          ease: 'easeOut',
          delay: Math.random() * 0.2
        }} className="absolute w-2 h-2 rounded-sm" style={{
          backgroundColor: CONFETTI_COLORS[i % CONFETTI_COLORS.length]
        }} data-id="element-361" />)}
          </>}
      </AnimatePresence>

      {/* Floating Mystic Particles */}
      {isInView && particles.map(p => <motion.div key={p.id} initial={{
      x: `${p.x}%`,
      y: '110%',
      opacity: 0
    }} animate={{
      y: '-10%',
      opacity: [0, 0.8, 0],
      x: `${p.x + Math.sin(p.angle) * 5}%`
    }} transition={{
      duration: p.duration + 5,
      repeat: Infinity,
      delay: p.delay,
      ease: 'linear'
    }} className="absolute rounded-full blur-[1px]" style={{
      width: p.size,
      height: p.size,
      backgroundColor: p.color,
      boxShadow: `0 0 10px ${p.color}`
    }} data-id="element-362" />)}
    </div>;
}
export function TitleSparkles() {
  return <div className="absolute inset-0 -m-4 pointer-events-none" data-id="element-363">
      {[...Array(6)].map((_, i) => <motion.div key={i} initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: [0, 1, 0],
      opacity: [0, 1, 0],
      rotate: [0, 90, 180]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      delay: i * 0.3,
      ease: 'easeInOut'
    }} className="absolute text-yellow-400" style={{
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`
    }} data-id="element-364">
          <Sparkles size={16} fill="currentColor" data-id="element-365" />
        </motion.div>)}
    </div>;
}